import { useState } from "react";

import useModule from "../../hooks/useModule";
import CustomTableLayout from "../CustomTableLayout";
import AppDrawer from "../../components/Drawers/AppDrawer";
import ShareRecordPage from "../../components/Drawers/ShareRecordDrawer/SharedRecordPage";
import SharedCenterSelectedRecordsActions from "./SharedCenterSelectedRecordsActions";

const mainLayout = {
  id: "2",
  Fields: [
    "RecordID",
    "Authentication",
    "Created",
    "CreatedBy",
    "LastUpdated",
    "LastUpdatedBy",
  ],
  ModuleAPIName: "SharedRecordsPage",
  Type: "Table",
};
const initialQuery = {
  _SelectedLayout: "2",
  Fields: [
    "_RecordName",
    "RecordID",
    "ViewID",
    "Authentication",
    "Created",
    "CreatedBy",
    "LastUpdated",
    "LastUpdatedBy",
  ],
  Filters: [],
  OrderBy: {
    Field: "Created",
    Direction: "DESC",
  },
  Pagination: {
    Count: 25,
    Page: 1,
  },
};

const hiddenFields = ["ViewID"];

const SharedRecordsPageCenter = () => {
  const { module } = useModule("SharedRecordsPage");
  const [openSharedRecordPage, setSharedRecordPage] = useState<{
    RecordID: string;
    ViewID: string;
  } | null>(null);

  if (!module) return;

  return (
    <>
      <CustomTableLayout
        title="Shared Record Pages"
        description="All the record pages shared in this cloud"
        module={module}
        layout={mainLayout}
        initialQuery={initialQuery}
        recordNameField="RecordID"
        hiddenFields={hiddenFields}
        onOpenRecordName={(data) => {
          const record = data.record;

          setSharedRecordPage({
            RecordID: record?.RecordID?.id,
            ViewID: record?.ViewID?.id,
          });
        }}
        SelectRecordsActions={SharedCenterSelectedRecordsActions}
      />
      <AppDrawer
        open={!!openSharedRecordPage}
        onClose={() => setSharedRecordPage(null)}
        headerTitle={"Share Page"}
        body={
          <ShareRecordPage
            recordID={openSharedRecordPage?.RecordID!}
            viewID={openSharedRecordPage?.ViewID!}
            recordModule={module?.APIName}
          />
        }
      />
    </>
  );
};

export default SharedRecordsPageCenter;
